
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    import userList from '@/store/entities/userinfo'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';

    class Packed {
        Id: null;
        shelfPosition: string;
        productName: string;
        purchaseCost?: number;
        length?: number;
        width?: number;
        height?: number;
        packCost?: number;
        volume?: number;
    }

    @Component
    export default class EditShilfPositionModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        selectuser: userList = new userList();
        user: Array<userList> = [];
        automaticJump: boolean;
        PackedModel: Packed = new Packed();

        // 使用字符串类型的中间变量来避免InputNumber自动格式化
        lengthStr: string = '';
        widthStr: string = '';
        heightStr: string = '';
        purchaseCostStr: string = '';
        packCostStr: string = '';
        volumeStr: string = '';

        created() { }

        // 处理小数输入，保留1位小数
        private parseDecimal(value: string, field: keyof Packed): number | undefined {
            if (!value || value.trim() === '') {
                return undefined;
            }

            // 移除前后空格
            const trimmed = value.trim();

            // 检查是否是有效的数字
            const num = parseFloat(trimmed);
            if (isNaN(num)) {
                return undefined;
            }

            // 限制1位小数
            const rounded = Math.round(num * 10) / 10;

            // 更新模型
            (this.PackedModel as any)[field] = rounded;

            return rounded;
        }

        // 将数字格式化为1位小数，并返回字符串
        private formatDecimal(num: number | string | null | undefined): string {
            if (num === null || num === undefined) {
                return '';
            }

            // 转换为数字
            const numberValue = typeof num === 'string' ? parseFloat(num) : num;

            if (isNaN(numberValue)) {
                return '';
            }

            // 如果是整数，直接返回整数形式，不加.0
            if (numberValue % 1 === 0) {
                return numberValue.toString();
            }

            // 否则格式化为1位小数
            return numberValue.toFixed(1);
        }

        // 处理失焦事件
        handleLengthBlur() {
            const value = this.parseDecimal(this.lengthStr, 'length');
            if (value !== undefined) {
                this.lengthStr = value.toString();
                // 如果是小数，格式化为1位小数
                if (value % 1 !== 0) {
                    this.lengthStr = value.toFixed(1);
                }
            } else {
                this.lengthStr = '';
                this.PackedModel.length = undefined;
            }
            this.calculateVolume();
        }

        handleWidthBlur() {
            const value = this.parseDecimal(this.widthStr, 'width');
            if (value !== undefined) {
                this.widthStr = value.toString();
                // 如果是小数，格式化为1位小数
                if (value % 1 !== 0) {
                    this.widthStr = value.toFixed(1);
                }
            } else {
                this.widthStr = '';
                this.PackedModel.width = undefined;
            }
            this.calculateVolume();
        }

        handleHeightBlur() {
            const value = this.parseDecimal(this.heightStr, 'height');
            if (value !== undefined) {
                this.heightStr = value.toString();
                // 如果是小数，格式化为1位小数
                if (value % 1 !== 0) {
                    this.heightStr = value.toFixed(1);
                }
            } else {
                this.heightStr = '';
                this.PackedModel.height = undefined;
            }
            this.calculateVolume();
        }

        handlePurchaseCostBlur() {
            const value = this.parseDecimal(this.purchaseCostStr, 'purchaseCost');
            if (value !== undefined) {
                this.purchaseCostStr = value.toString();
                // 如果是小数，格式化为1位小数
                if (value % 1 !== 0) {
                    this.purchaseCostStr = value.toFixed(1);
                }
            } else {
                this.purchaseCostStr = '';
                this.PackedModel.purchaseCost = undefined;
            }
        }

        handlePackCostBlur() {
            const value = this.parseDecimal(this.packCostStr, 'packCost');
            if (value !== undefined) {
                this.packCostStr = value.toString();
                // 如果是小数，格式化为1位小数
                if (value % 1 !== 0) {
                    this.packCostStr = value.toFixed(1);
                }
            } else {
                this.packCostStr = '';
                this.PackedModel.packCost = undefined;
            }
        }

        // 计算体积的方法
        calculateVolume() {
            const { length, width, height } = this.PackedModel;

            if (length !== null && length !== undefined &&
                width !== null && width !== undefined &&
                height !== null && height !== undefined) {

                // 转换为数字并计算体积（立方厘米）
                const l = Number(length);
                const w = Number(width);
                const h = Number(height);

                if (!isNaN(l) && !isNaN(w) && !isNaN(h)) {
                    // 体积 = 长 × 宽 × 高
                    const vol = l * w * h;
                    this.PackedModel.volume = parseFloat(vol.toFixed(3));
                    this.volumeStr = vol.toFixed(3);
                    return;
                }
            }

            // 如果缺少任何值，清除体积
            this.PackedModel.volume = undefined;
            this.volumeStr = '';
        }

        async check() {
            (this.$refs.packForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    // 在保存前确保所有字段都已处理
                    this.handleLengthBlur();
                    this.handleWidthBlur();
                    this.handleHeightBlur();
                    this.handlePurchaseCostBlur();
                    this.handlePackCostBlur();

                    this.PackedModel.Id = this.$store.state.backstockproduct.id;
                    await this.$store.dispatch({
                        type: 'backstockproduct/EditShelfPosition',
                        data: this.PackedModel
                    });
                    (this.$refs.packForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            });
        }

        cancel() {
            (this.$refs.packForm as any).resetFields();
            // 清空所有字符串变量
            this.lengthStr = '';
            this.widthStr = '';
            this.heightStr = '';
            this.purchaseCostStr = '';
            this.packCostStr = '';
            this.volumeStr = '';
            this.$emit('input', false);
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                // 清空字符串变量
                this.lengthStr = '';
                this.widthStr = '';
                this.heightStr = '';
                this.purchaseCostStr = '';
                this.packCostStr = '';
                this.volumeStr = '';

                // 从store设置值
                this.$set(this.PackedModel, "shelfPosition", this.$store.state.backstockproduct.shelfPosition);
                this.$set(this.PackedModel, "productName", this.$store.state.backstockproduct.productName);

                // 设置数值字段的辅助方法
                const setNumericField = (field: keyof Packed, storeField: string) => {
                    const value = this.$store.state.backstockproduct[storeField];

                    if (value !== null && value !== undefined) {
                        // 确保是数字类型
                        const numValue = typeof value === 'string' ? parseFloat(value) : Number(value);

                        if (!isNaN(numValue)) {
                            // 更新PackedModel
                            (this.PackedModel as Record<keyof Packed, any>)[field] = numValue;

                            // 设置对应的字符串变量
                            const strField = field + 'Str';

                            // 如果是整数，直接显示整数，不加.0
                            if (numValue % 1 === 0) {
                                (this as any)[strField] = numValue.toString();
                            } else {
                                // 否则格式化为1位小数
                                (this as any)[strField] = numValue.toFixed(1);
                            }
                        }
                    }
                };

                // 设置所有数值字段
                setNumericField('purchaseCost', 'purchaseCost');
                setNumericField('length', 'length');
                setNumericField('width', 'width');
                setNumericField('height', 'height');
                setNumericField('packCost', 'packCost');

                // 初始化时也计算体积
                setTimeout(() => {
                    this.calculateVolume();
                }, 100);
            }
        }

        costRule = {
            shelfPosition: [
                { required: true, message: '货架号不能为空', trigger: 'blur' }
            ],
            productName: [
                { required: true, message: '产品名称不能为空', trigger: 'blur' }
            ],
        };
    }
